export enum offerCategoryEnum {
  PARTNER_ACQUISITION = 'partner_acquisition',
  PAYMENT_PARTNER = 'payment_partner',
  NO_COST_EMI = 'no_cost_emi',
  CASHBACK_OFFER = 'cashback_offer',
}

export enum Pages {
  TWID_BANK_PAYMENT = 11.3,
  ORDER_NOW_PAY_LATER = 21,
  PAYMENT_METHODS = 7,
  FLIP_CARD = 12,
  CARD_PAYMENT = 11,
  ADDRESS_1 = 3,
  ADDRESS_2 = 4,
  ADDRESS_LISTING = 5,
  UPI_PAGE = 8,
  ERROR_PAGE = -1,
  EMI_PAGE = 11.1,
  GOKWIK_BNPL = 15,
  WALLETS = 14,
  NETBANKING = 11.2,
  LOGIN = 1,
  LOGIN_OTP = 2,
}

export enum RewardType {
  BURN = 'burn',
  EARN = 'earn',
  BURN_EARN = 'burn_earn',
}

export enum OfferPartner {
  CRED = 'cred',
}

export enum OfferType {
  MANUAL = 'manual',
  AUTO = 'auto',
}

export enum DiscountType {
  LOYALTY = 'loyalty',
  CREDITS = 'credits',
  SHOPIFY = 'shopify',
  ABC = 'abc',
  PAYMENT_OFFER = 'payment_offer',
}
